/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISurgicalAppointment } from 'app/shared/model/surgical-appointment.model';
import { ISurgicalAppointmentAttributeType } from 'app/shared/model/surgical-appointment-attribute-type.model';
import { UserType } from 'app/shared/model/enumerations/user-type.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface ISurgicalAppointmentAttribute {
  id?: string;
  value?: string;
  participantType?: keyof typeof UserType;
  participantId?: string;
  active?: boolean | null;
  cursor?: number | null;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof AddedByType | null;
  modifiedByType?: keyof typeof AddedByType | null;
  role?: string;
  schedule?: ISurgicalAppointment;
  attributeType?: ISurgicalAppointmentAttributeType | null;
}

export const defaultValue: Readonly<ISurgicalAppointmentAttribute> = {
  active: false,
};
